<template>
<v-card>

    <v-list>
        <v-list-item>
            <v-list-item-avatar height="50" width="50">
                <v-icon id="user-icon" v-if="!$store.state.userImage">fa fa-user-circle</v-icon>
                <img class="user-image" v-if="$store.state.userImage" :src="$store.state.userImage" />
            </v-list-item-avatar>

            <v-list-item-content>
                <v-list-item-title>{{ $store.state.user.user_username }}</v-list-item-title>
                <v-list-item-subtitle>{{ $store.state.user.user_fullname }}</v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
    </v-list>

    <v-divider></v-divider>

    <v-card-actions>
        <v-btn icon @click="goToAdminPage" v-if="isTsAdmin"><v-icon color="#FFD700">mdi-key-variant</v-icon></v-btn>
        <v-btn icon @click="goToDatabasePage" v-if="isTsAdmin"><v-icon color="#FFD700">mdi-database</v-icon></v-btn>
        <v-btn icon @click="goToLogPage" v-if="isTsAdmin"><v-icon color="#FFD700">mdi-card-text</v-icon></v-btn>
        <div class="flex-grow-1"></div>
        <v-btn text @click="menu = false">Close</v-btn>
        <v-btn color="#DC3545" text @click="$emit('logout')">Logout</v-btn>
    </v-card-actions>

        

</v-card>
</template>

<script>
export default {
    name: 'UserInfo',
    data: () => ({

    }),

    computed: {
        isTsAdmin: function() {
            if(this.$store.state.user.user_data && this.$store.state.user.user_data.is_telsasoft_admin) {
                return true;
            }
            return false;
        }
    },

    methods: {
        goToAdminPage: function() {
            this.$router.push('tsadmin');
        },

        goToDatabasePage: function() {
            this.$router.push('dbinfo');
        },

        goToLogPage: function() {
            this.$router.push('applicationlogs');
        }
    },

    mounted() {

    },
  
};
</script>

<style scoped>

    .user-image {
        width: 50px;
        height: 50px;
        box-shadow: 3px 3px 8px 0px rgba(0,0,0,0.3);
    }

    #user-icon {
        font-size: 50px;
        box-shadow: 3px 3px 8px 0px rgba(0,0,0,0.3);
    }

</style>

